export const StorageLocation: Array<{
  id: number;
  name: string;
}> = [
  { name: "Kiste", id: 0 },
  { name: "Kühlschrank", id: 1 },
  { name: "Tresor", id: 2 },
];
